import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { LanguageListRes } from "../../types/ResType";

export const useFetchLanguageList = () => {
  return useQuery<LanguageListRes, Error>(
    ["language/get-language"],
    async () => {
      const response = await axiosInstance.post<LanguageListRes>("language/get-language", {});
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: 1,
      retryDelay: 2000,
    },
  );
};
